/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {secureTransferInformation} from '../api'

export const useMutationSecureTransferInformation = createReactQueryMutationHook('secureTransferInformation', secureTransferInformation)
